import { createSlice } from '@reduxjs/toolkit';
import forOwn from 'lodash/forOwn';

import { RESCHEDULE_CLASSES_STAGES } from '@classCreation/data/rescheduleClassesStages';

const initialState = {
  rescheduleClassesStage: RESCHEDULE_CLASSES_STAGES.view,
  academySchedule: null,
  startDate: null,
  sbatGroups: {},
  errors: {},
  communications: {},
  rescheduleReason: null,
  bulkRescheduleValidateErrorMessage: null,
};

const rescheduleClassesForm = createSlice({
  name: 'rescheduleClassesForm',
  initialState,
  reducers: {
    setRescheduleClassesStage(state, action) {
      state.rescheduleClassesStage = action.payload;
    },
    setRescheduleClassesFormAcademySchedule(state, action) {
      state.academySchedule = action.payload;
      state.startDate = null;
    },
    rescheduleClassesFormSetStartDate(state, action) {
      state.startDate = action.payload;
    },
    setSbatGroups(state, action) {
      state.sbatGroups = action.payload.reduce((result, sbatGroup, index) => {
        return {
          ...result,
          [sbatGroup.id]: {
            ...sbatGroup,
            newDateOfTopic: null,
            order: index,
          },
        };
      }, {});
    },
    setSbatGroupsDate: (state, action) => {
      const { dates } = action.payload;
      forOwn(state.sbatGroups, (sbatGroup) => {
        // Or condition will be used to clone the existing date of topic
        // for locked classes.
        sbatGroup.newDateOfTopic =
          dates[sbatGroup.id] || new Date(sbatGroup.date_of_topic).getTime();
      });
    },
    setSbatGroupLocked(state, action) {
      const { sbatGroupId, locked } = action.payload;
      state.sbatGroups[sbatGroupId].locked = locked;
    },
    setSbatGroupDate(state, action) {
      const { sbatGroupId, dateOfTopic } = action.payload;
      state.sbatGroups[sbatGroupId].newDateOfTopic = dateOfTopic;
    },
    setRescheduleClassesFormErrors(state, action) {
      state.errors = action.payload;
    },
    setBulkRescheduleReason: (state, action) => {
      state.rescheduleReason = action.payload;
    },
    setBulkRescheduleCommunications: (state, action) => {
      state.communications[action.payload.channel] = action.payload.enabled;
    },
    setBulkRescheduleValidateErrorMessage: (state, action) => {
      state.bulkRescheduleValidateErrorMessage = action.payload;
    },
    resetRescheduleClassesForm(state) {
      state.academySchedule = null;
      state.startDate = null;
      state.sbatGroups = {};
      state.errors = {};
      state.communications = {};
      state.rescheduleReason = null;
    },
  },
});

export const {
  setRescheduleClassesStage,
  setRescheduleClassesFormAcademySchedule,
  rescheduleClassesFormSetStartDate,
  setSbatGroups,
  setSbatGroupLocked,
  setSbatGroupsDate,
  setSbatGroupDate,
  setRescheduleClassesFormErrors,
  setBulkRescheduleReason,
  setBulkRescheduleCommunications,
  setBulkRescheduleValidateErrorMessage,
  resetRescheduleClassesForm,
} = rescheduleClassesForm.actions;

export default rescheduleClassesForm.reducer;
